import { initialTableShow } from 'utils/settings';

export const mainTableConf = [
  {
    isSortable: true,
    field: 'firstName',
    title: 'Member',
    show: true,
    width: 300,
    valuesExport: ['firstName', 'lastName', 'email']
  },
  {
    isSortable: true,
    field: 'hostname',
    title: 'Host Name',
    show: true,
    width: 152,
    valuesExport: ['hostname']
  },
  {
    isSortable: false,
    field: 'os',
    title: 'OS',
    show: true,
    width: 152,
    valuesExport: ['os']
  },
  {
    isSortable: false,
    field: 'osVersion',
    title: 'OS version',
    show: true,
    width: 202,
    valuesExport: ['osVersion']
  },
  {
    isSortable: true,
    field: 'deviceType',
    title: 'Device Type',
    show: true,
    width: 152,
    valuesExport: ['deviceType']
  },
  {
    isSortable: true,
    field: 'appVersion',
    title: 'App Ver',
    show: true,
    width: 152,
    valuesExport: ['appVersion']
  },
  {
    isSortable: true,
    field: 'lastDeviceLogin',
    title: 'Last Agent Login',
    show: true,
    width: 176,
    valuesExport: ['lastDeviceLogin']
  },
  {
    isSortable: true,
    field: 'postureCheckStatus',
    title: 'DPC Status',
    show: true,
    width: 152,
    valuesExport: ['postureCheckStatus']
  },
  {
    isSortable: false,
    field: 'lastPostureCheckAt',
    title: 'Last DPC',
    show: true,
    width: 152,
    valuesExport: ['lastPostureCheckAt']
  },
  {
    isSortable: false,
    field: 'attachedPolicyProfileName',
    title: 'Attached Policy',
    show: true,
    width: 152,
    valuesExport: ['attachedPolicy.profileName']
  },
  {
    isSortable: true,
    field: 'role',
    title: 'Role',
    show: true,
    width: 152,
    valuesExport: ['role']
  },
  {
    isSortable: true,
    field: 'localeIdentifier',
    title: 'Locale Identifier',
    show: true,
    width: 176,
    valuesExport: ['localIdentifier']
  },
  {
    isSortable: false,
    field: 'groups',
    title: 'Groups',
    show: true,
    width: 152,
    valuesExport: ['groups']
  },
  {
    isSortable: false,
    field: 'idp',
    title: 'IdP',
    show: true,
    width: 152,
    valuesExport: ['idp']
  }
];

export const exportConfig = {
  exportUrl: '/customer/platform/devices/export',
  exportName: 'platform_devices_',
  exportFormat: 'zip'
};

export const defaultFilters = {
  search: '',
  deviceType: [],
  os: [],
  osVersion: [],
  appVersion: [],
  timezone: [],
  role: [],
  groups: [],
  lastDeviceLogin: { startDate: null, endDate: null },
  idp: [],
  postureCheckStatus: [],
  lastPostureCheckAt: { startDate: null, endDate: null },
  attachedPolicy: []
};

export const defaultNavigation = {
  fieldName: 'lastDeviceLogin',
  direction: initialTableShow.direction,
  currentPage: initialTableShow.currentPage,
  itemsPerPage: initialTableShow.itemsPerPage
};

export const dpcChartColor = {
  '-': '#dde6f2',
  na: '#dde6f2',
  healthy: '#6fcdcd',
  'not healthy': '#ff829d'
};
